import moment from 'moment';

export const usersLoginsConfigs = {
  api: () => '/adminActivities',
  title: 'Login Activity',
  isActionTab: false,
  modalTitle: (action) => `${action} ${usersLoginsConfigs.title}`,
  getColumns: () => {
    return [
      {
        title: 'Name',
        dataIndex: 'users',
        key: 'users',
        isSearch: true,
        render: (users) => {
          return [users.firstName, users.middelName, users.lastName]
            .filter(Boolean)
            .join(' ');
        },
      },
      {
        title: 'Date',
        dataIndex: '_id',
        key: '_id',
        isSearch: true,
        render: (date) => {
          return moment(date.startDate).format('ll');
        },
      },
      {
        title: 'Total Time Spent',
        dataIndex: 'totalCount',
        key: 'totalCount',
        isSearch: false,
        showSorterTooltip: true,
      },
      {
        title: 'Total Activity Happens',
        dataIndex: 'dateWiseList',
        key: 'dateWiseList',
        isSearch: true,
        render: (dateWiseList) => {
          return dateWiseList.length;
        },
      },
      {
        title: 'Login Status',
        dataIndex: 'dateWiseList',
        key: 'dateWiseList',
        isSearch: true,
        render: (dateWiseList) => {
          const count = dateWiseList.filter(
            (ele) => ele.isInProcess !== 'Stop'
          );
          return count.length > 0 ? count[0].isInProcess : 'Stop';
        },
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        type: 'renderHtml',
        render: (status) => {
          if (status == 'Less Activity') {
            return `<div class="red_c">${status}</div>`;
          } else if (status == 'High Activity') {
            return `<div class="oranage_c">${status}</div>`;
          } else {
            return `<div class="blue_c">${status}</div>`;
          }
        },
      },
    ];
  },
  getFormColumns: () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        isRequired: true,
        formClassName: 'col-8 pb-2',
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        type: 'textarea',
        isRequired: false,
        formClassName: 'col-8 pb-2',
      },
    ];
  },
  getData: () => ({}),
  actions: [
    // { name: 'Add Designation', isModal: true, settings: { type: 'primary' } },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};
